import { CardList } from "../components/CardList/CardList";

const Tweets = () => {
  return (
    <main>
      <CardList />
    </main>
  );
};

export default Tweets;
